import { ReportLabelInspectionAreaStatus } from '@ulysses-inc/harami_api_client'

export const labelAreaResultStatusColor = {
  ok: '#2E7D32',
  manualOk: '#2E7D32',
  manualNg: '#D32F2F',
  ng: '#D32F2F',
  unknown: '#EF6C00',
  undetected: '#D32F2F',
} as const satisfies Record<ReportLabelInspectionAreaStatus, string>

export const labelAreaResultStatusLabel = {
  ok: 'OK',
  ng: 'NG',
  manualOk: '手動OK',
  manualNg: '手動NG',
  unknown: '要確認',
  undetected: '未検出',
} as const satisfies Record<ReportLabelInspectionAreaStatus, string>
